import EnrollmentApp from 'modules/EnrollmentPage';
import React, { useState } from 'react';
import { ProtectedVisibility } from 'shared/security/ProtectedRoute';
import { getCurrentUserProfile, getKeycloakUserValidity, getUserRoleProfileId } from 'shared/utils/SessionDataUtils';
import { useKeycloak } from '../../../node_modules/@react-keycloak/web/lib/useKeycloak';
import { useLoading } from 'shared/contexts/Loading';
import apiCall from 'shared/services/ApiAdapter';

// Displays temporary success, error, or info messages.
const HomeApp = ({ displayToast }) => {
    const userId = getUserRoleProfileId();
    const userValidity = getKeycloakUserValidity();

    const { keycloak } = useKeycloak();


    const handleLogout = () => {
        if (keycloak?.logout) {
            keycloak.logout({ redirectUri: window.location.origin });
        }
        // navigateTo("home");
    };

    return (
        <>
            {userValidity ? (
                <>
                    <ProtectedVisibility requiredRoles={['ROLE_TEACHER']}>
                        <EnrollmentApp
                            curPage='teacherDashboard'
                            displayToast={displayToast}
                        />
                    </ProtectedVisibility>
                    <ProtectedVisibility requiredRoles={['ROLE_PARENT']}>
                        <EnrollmentApp
                            curPage='students'
                            studentId={userId}
                            displayToast={displayToast}
                        />
                    </ProtectedVisibility>
                    <ProtectedVisibility requiredRoles={['ROLE_STUDENT']}>
                        <EnrollmentApp
                            curPage='studentHub'
                            studentId={userId}
                            displayToast={displayToast}
                        />
                    </ProtectedVisibility>
                </>
            ) : (
                /* --- FIXED SECTION START --- */
                AdminApprovalRequried(displayToast, handleLogout)
                /* --- FIXED SECTION END --- */
            )}
        </>
    );
};

export default HomeApp;

function AdminApprovalRequried(displayToast, handleLogout) {
    const [showButton, setShowButton] = useState(true);
    const userProfile = getCurrentUserProfile();

    const sendAccessRequest = () => {
        apiCall("/email/AccessRequest/send", null, "POST",
            {
                "to": "rajesh.biswal@gmail.com",
                "subject": `Access requested`,
                "userName": `${userProfile?.email}`
            },
            undefined, undefined, displayToast);
        displayToast("access requested");
        setShowButton(false);
    }

    return <div className="bg-gray-50 flex items-center justify-center min-h-screen p-4 w-full">
        <div className="max-w-md w-full bg-white rounded-xl shadow-lg overflow-hidden border border-gray-100">

            {/* Header */}
            <div className="bg-amber-50 p-6 text-center border-b border-amber-100">
                <div className="mx-auto flex items-center justify-center  rounded-full ">
                    <img src="logo.png" alt="SahajGyan" className="h-15" />
                </div>
                <h3 className="text-xl font-bold text-gray-900">Approval Pending</h3>
                <p className="text-sm text-gray-500">Your account is currently under review.</p>
            </div>

            {/* Body */}
            <div className="p-6 space-y-4">
                <div className="text-gray-600 text-center leading-relaxed">
                    <p> Thank you for registering!</p>
                    <p>To ensure security, an administrator must approve your account before you can access the platform.</p>
                </div>

                <div className="bg-blue-50 rounded-lg p-4 flex items-start space-x-3">
                    <svg className="h-6 w-6 text-blue-500 flex-shrink-0 mt-0.5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <div className="text-sm text-blue-700">
                        <span className="font-semibold block mb-1">What happens next?</span>
                        You will receive an email notification once your account has been activated. This usually takes 24-48 hours.
                    </div>
                </div>

                {showButton == true &&
                    <div className="text-center pt-2">
                        <p className="text-sm text-gray-500 mb-2">Need immediate access or have questions?</p>
                        <button onClick={() => sendAccessRequest()} className={`px-5 py-2 rounded-lg font-medium transition-colors
                bg-gray-600 text-gray-100 hover:bg-gray-700 dark:bg-gray-600 dark:hover:bg-gray-500`}>
                            Click here to request access
                        </button>
                    </div>
                }
            </div>

            {/* Footer */}
            <div className="bg-gray-50 px-6 py-4 text-center">
                <button onClick={handleLogout} className="text-sm text-gray-500 hover:text-gray-900 font-medium transition-colors">
                    Log out and return to home
                </button>
            </div>
        </div>
    </div>;
}
